import { render, staticRenderFns } from "./VdAccessModal.vue?vue&type=template&id=3b2ba2eb&"
import script from "./VdAccessModal.vue?vue&type=script&lang=js&"
export * from "./VdAccessModal.vue?vue&type=script&lang=js&"
import style0 from "./VdAccessModal.vue?vue&type=style&index=0&id=3b2ba2eb&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports